import { Component } from '@angular/core';

@Component({
  selector: 'btn-content-linkedin',
  templateUrl: './btn-content-linkedin.component.html',
  styleUrls: ['./btn-content-linkedin.component.scss']
})
export class BtnContentLinkedinComponent {
}
